<template>
  <section>
    <gs-header
      title="Thêm mới hãng vận chuyển"
      :breadcrumbs="[
        {title: 'Quản lý hãng vận chuyển', route: {name: 'carrier'}}
      ]"
    >
    </gs-header>
    <div class="padding-sm-all">
      <el-form
        label-position="top"
        class="margin-top"
        :rules="rules"
        ref="create-carrier-form"
        :model="localCarrier"
        label-width="150px"
        @submit.prevent.native="validatorBeforeSubmit"
      >
        <el-row
          :gutter="20"
          class="remove-margin"
        >
          <el-col :span="12">
            <el-form-item
              label="Tên"
              prop="name"
            >
              <el-input
                v-model="localCarrier.name"
                placeholder="Tên"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Tên rút gọn"
              prop="short_name"
            >
              <el-input
                v-model="localCarrier.short_name"
                placeholder="Tên rút gọn"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Cân nặng quy đổi"
              prop="weight_rate"
            >
              <el-input
                v-model="localCarrier.weight_rate"
                placeholder="Cân nặng quy đổi"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Logo">
              <el-upload
                class="avatar-uploader"
                :action="uploadLogoUrl"
                :headers="uploadHeader"
                :show-file-list="false"
                :on-success="handleLogoUpload"
                :before-upload="beforeLogoUpload"
              >
                <img
                  v-if="logo.path"
                  :src="logo.path"
                  class="avatar"
                >
                <i
                  v-else
                  class="el-icon-plus avatar-uploader-icon"
                ></i>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row
          :gutter="20"
          class="remove-margin"
        >
          <!-- <el-col :span="8">
            <el-form-item label="Phí chuyển hoàn" prop="return_fee">
              <el-input @focus="removeZero('return_fee')" @blur="addZero('return_fee')" v-model="localCarrier.return_fee" placeholder="Phí chuyển hoàn">
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col> -->
          <el-col :span="6">
            <el-form-item
              label="VAT"
              prop="vat_fee"
            >
              <el-input
                @focus="removeZero('vat_fee')"
                @blur="addZero('vat_fee')"
                v-model="localCarrier.vat_fee"
                placeholder="VAT"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Phí dịch vụ"
              prop="service_fee"
            >
              <el-input
                @focus="removeZero('service_fee')"
                @blur="addZero('service_fee')"
                v-model="localCarrier.service_fee"
                placeholder="Phí bảo hiểm"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Phí bảo hiểm"
              prop="insurrance_fee"
            >
              <el-input
                @focus="removeZero('insurrance_fee')"
                @blur="addZero('insurrance_fee')"
                v-model="localCarrier.insurrance_fee"
                placeholder="Phí bảo hiểm"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Phí xăng dầu"
              prop="oil_fee"
            >
              <el-input
                @focus="removeZero('oil_fee')"
                @blur="addZero('oil_fee')"
                v-model="localCarrier.oil_fee"
                placeholder="Phí xăng dầu"
              >
                <template slot="append">%</template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col
            :span="6"
            class="adddon-1"
          >
            <el-form-item
              label="Hệ số vùng xa"
              prop="remote_area_fee"
            >
              <el-input
                @focus="removeZero('remote_area_fee')"
                @blur="addZero('remote_area_fee')"
                v-model="localCarrier.remote_area_fee"
                placeholder="Hệ số vùng xa"
              >
                <el-select
                  v-model="localCarrier.remote_area_unit"
                  slot="append"
                  placeholder="Select"
                >
                  <el-option
                    label="%"
                    :value="0"
                  ></el-option>
                  <el-option
                    label="đ"
                    :value="1"
                  ></el-option>
                </el-select>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item
              label="Url check mã vận đơn"
              prop="tracking_url"
            >
              <el-input
                v-model="localCarrier.tracking_url"
                placeholder="Url check mã vận đơn"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="Ghi chú">
              <el-input
                type="textarea"
                v-model="localCarrier.note"
                placeholder="Ghi chú"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item
              label="Giao hàng thu tiền"
              prop="is_cash"
            >
              <el-checkbox v-model="localCarrier.is_cash">Giao hàng thu tiền</el-checkbox>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <button
              :disabled="submitting"
              class="ui blue basic small button"
              native-type="submit"
            ><i class="fa fa-floppy-o"></i> Lưu lại</button>
          </el-col>
        </el-row>
      </el-form>
    </div>
  </section>
</template>

<script>
import { head } from 'lodash'
import { addCarrier } from 'src/api/carrier'
import carrierMixin from './mixins'
export default {
  name: 'NewCarrier',
  mixins: [carrierMixin],
  methods: {
    validatorBeforeSubmit () {
      this.submitting = true
      this.$refs['create-carrier-form'].validate((valid) => {
        if (valid) {
          this.toggleLoadding()
          this.changedData = false
          addCarrier(this.localCarrier).then(response => {
            switch (response.code) {
              case 200:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thành công',
                  body: 'Tạo mới hãng vận chuyển thành công',
                  type: 'success'
                })
                this.reloadGsTableAfterRedirect({ name: 'carrier' }, 'carriers')
                this.toggleLoadding(false)
                break
              case 422:
                this.submitting = false
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$store.dispatch('showNotify', {
                  title: 'Vui lòng kiểm tra thông tin cần nhập',
                  body: message,
                  type: 'warning'
                })
                this.toggleLoadding(false)
                break
              default:
                this.submitting = false
                this.$store.dispatch('showNotify', {
                  title: 'Thêm mới thất bại',
                  body: 'Tạo hãng vận chuyển thất bại vui lòng kiểm tra lại thông tin',
                  type: 'danger'
                })
                this.toggleLoadding(false)
            }
          })
        } else {
          this.submitting = false
          this.$store.dispatch('showNotify', {
            title: 'Vui lòng kiểm tra thông tin cần nhập',
            type: 'warning'
          })
          return false
        }
      })
    },
    newCarrier () {
      this.localCarrier = {
        // return_fee: 0,
        vat_fee: 0,
        insurrance_fee: 0,
        oil_fee: 0,
        remote_area_fee: 0,
        remote_area_unit: 0,
        logo: undefined,
        name: '',
        short_name: '',
        tracking_url: '',
        is_cash: false,
        service_fee: 0
      }
      setTimeout(() => {
        this.watching = true
      }, 100)
    }
  }
}
</script>
<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// NewCarrier.vue?f7f0df6c